import { cva, type VariantProps } from "class-variance-authority";

/**
 * Atelier Input — symmetric rounded-atelier-md (14px) on all 4 corners.
 * Locked rule: inputs are never asymmetric (bubbles only).
 */
export const inputVariants = cva(
  [
    "w-full",
    "bg-atelier-surface-raised",
    "text-atelier-ink-primary",
    "placeholder:text-atelier-ink-muted",
    "rounded-atelier-md",
    "border border-atelier-border",
    "transition-colors duration-[120ms] ease-out",
    "atelier-focus-ring",
    "disabled:cursor-not-allowed disabled:opacity-60 disabled:bg-atelier-surface-muted",
    "focus:border-atelier-brand",
  ].join(" "),
  {
    variants: {
      size: {
        sm: "h-9 px-3 text-sm",
        md: "h-11 px-4 text-sm",
        lg: "h-12 px-5 text-base",
      },
      invalid: {
        true: "border-atelier-danger focus:border-atelier-danger",
        false: "",
      },
    },
    defaultVariants: {
      size: "md",
      invalid: false,
    },
  },
);

export type InputVariantsProps = VariantProps<typeof inputVariants>;
